import React from "react";

const BannerLineas = props => (
  <section id="banner" className="style2" style={{ backgroundImage: `url(${props.image})` }}>
    <div className="inner">
      <header className="major">
        <h1>{props.title}</h1>
      </header>
      <div className="content">
        <p>{props.subTitle}</p>
      </div>
    </div>
  </section>
);

export default BannerLineas;
